<template>
  <div class="tvLoading">
    <div class="box">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tvLoading'
}
</script>

<style lang="scss" scoped>
@keyframes top {
  0% {top: 0; border-radius: 100%; transform: rotate(0);}
  25% {top: -15px; border-radius: 0; transform: rotate(180deg);}
  50% {top: 0; border-radius: 100%; transform: rotate(0);}
  75% {top: 15px; border-radius: 0; transform: rotate(180deg);}
  100% {top: 0; border-radius: 100%; transform: rotate(0);}
}
@keyframes mid {
  0% {border-radius: 100%; transform: rotate(0);}
  25% {border-radius: 0; transform: rotate(180deg);}
  50% {border-radius: 100%; transform: rotate(0);}
  75% {border-radius: 0; transform: rotate(180deg);}
  100% {border-radius: 100%; transform: rotate(0);}
}
@keyframes bottom {
  0% {top: 0; border-radius: 100%; transform: rotate(0);}
  25% {top: 15px; border-radius: 0; transform: rotate(180deg);}
  50% {top: 0; border-radius: 100%; transform: rotate(0);}
  75% {top: -15px; border-radius: 0; transform: rotate(180deg);}
  100% {top: 0; border-radius: 100%; transform: rotate(0);}
}
.tvLoading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.2);
  z-index: 999;
}
.box {
  white-space: nowrap;
  transform-origin: 50% 50%;
  animation-name: rotate;
  animation-duration: 6s;
  animation-iteration-count: infinite;
}
.dot {
  display: inline-block;
  position: relative;
  width: 10px;
  height: 10px;
  margin: 0 3px;
  border-radius: 100%;
  border: 1px solid $color-white;
  box-shadow: 0 0 5px rgba(0,0,0,0.5);
  background-color: $color-white;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  &:nth-of-type(1) {
    animation-name: top;
    background-color: #de5c5c;
  }
  &:nth-of-type(2) {
    animation-name: mid;
    background-color: #b6e85f;
  }
  &:nth-of-type(3) {
    animation-name: bottom;
    background-color: #00baff;
  }
}
</style>
